import config from "@/config"
import http from "@/utils/request"

export default {
	question: {
		url: `${config.MAIN_URL}/api/v1/point/question`,
		name: "本场气象-提问,详情",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	answer: {
		url: `${config.MAIN_URL}/api/v1/point/answer`,
		name: "本场气象-答案,详情",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	list: {
		url: `${config.MAIN_URL}/api/v1/questions`,
		name: "问题列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	delete: {
		url: `${config.MAIN_URL}/api/v1/question`,
		name: "问题列表",
		delete: async function (params) {
			return await http.delete(this.url + params);
		}
	},
	schema: {
		url: `${config.MAIN_URL}/user/v1/question/schema`,
		name: "列表详情",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	weatherMessage: {
		url: `${config.MAIN_URL}/api/v1/weatherMessage/data`,
		name: "气象报文",
		get: async function (data = {}) {
			return await http.get(this.url+ data);
		}
	},

}


